import { render } from "./info.vue?vue&type=template&id=06d85648"
import script from "./info.vue?vue&type=script&lang=ts"
export * from "./info.vue?vue&type=script&lang=ts"

import "./info.vue?vue&type=style&index=0&id=06d85648&lang=less"
script.render = render

export default script